:host .facility-list__title{font-weight:400;font-size:16px;font-family:GothamNarrowBook,sans-serif;color:#8c8f93}:host .facility-list__body{display:flex;flex-direction:column;gap:8px}
/*# sourceMappingURL=facility-list.component-NUOEXP2R.css.map */
